import { pageCollectionFields } from 'drapcode-constant';
export default function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { pageCollection, pfx, collections, projectId } = opts;
  domc.addType('browser-storage-setter', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          name: 'Browser Storage Setter',
          resizable: 1,
          droppable: false, // Can't drop other elements inside
          collectionName: '',
          collectionFrom: '',
          icon: '<i class="wb webconnect-list-task"></i>',
          finderUuid: '',
          numberPerPage: 10,
          projectId: projectId,
          serverUrl: `${process.env.REACT_EXCHANGE_ENGINE}`,
          traits: [
            {
              type: 'browser-storage-setter-collection',
              label: false,
              name: 'collectionName',
              changeProp: 1,
            },
            {
              type: 'text',
              label: 'Key',
              name: 'data-storagekey',
              value: 'browserStorage',
              placeholder: 'eg. browserStorage',
            },
            {
              type: 'select',
              label: 'Select storage option',
              name: 'data-browserstorage',
              default: 'SESSION_STORAGE',
              options: [
                {
                  value: 'SESSION_STORAGE',
                  name: 'Session Storage',
                },
                { value: 'LOCAL_STORAGE', name: 'Local Storage' },
                { value: 'COOKIES', name: 'Cookies' },
                { value: 'INDEXED_DB', name: 'IndexedDB' },
              ],
            },
            {
              type: 'number',
              label: 'Records Per Page',
              name: 'numberPerPage',
              changeProp: 1,
              value: '{[numberPerPage]}',
            },
            ...domc.getType('default').model.prototype.defaults.traits,
          ],
          script: function () {
            let collectionId = '{[ collectionName ]}';
            const finderId = '{[ finderUuid ]}';
            const fieldName = '{[ fieldName ]}';
            const recordsPerPage = '{[ numberPerPage ]}';
            let collectionFrom = '{[ collectionFrom ]}';
            let sessionDataPath = '{[ sessionDataPath ]}';
            let selectedCollectionData = '{[ selectedCollectionStr ]}';
            selectedCollectionData = selectedCollectionData.replaceAll('**##', '"');
            const externalQueryParamKeys = [];
            if (selectedCollectionData && selectedCollectionData !== 'undefined') {
              selectedCollectionData = JSON.parse(selectedCollectionData);
              const selectedFilter = selectedCollectionData.finders.find(
                (finder) => finder.uuid === finderId,
              );

              if (selectedFilter && selectedFilter.conditions) {
                selectedFilter.conditions.forEach((condition) => {
                  if (condition.requiredExternal) {
                    const {
                      query: { value },
                    } = condition;
                    if (value.includes('---')) {
                      const values = value.split('---');
                      externalQueryParamKeys.push(values[0]);
                      externalQueryParamKeys.push(values[1]);
                    } else {
                      externalQueryParamKeys.push(value);
                    }
                  }
                });
              }
            }

            const dataGroup = this.cloneNode(true);
            let paginationData = {};
            paginationData.numberPerPage = recordsPerPage ? recordsPerPage : 5;
            paginationData.filteredItemsUrl = `collection-table/${collectionId}/finder/${finderId}/items`;
            paginationData.dataGroupChildren = dataGroup ? dataGroup.children : [];
            paginationData.currentPage = 1;
            paginationData.currentDateRange = 0;
            paginationData.dataGroup = this;
            paginationData.numberOfPages = 0;
            paginationData.finderId = finderId;
            paginationData.collectionName = collectionId;
            paginationData.fieldName = fieldName;
            paginationData.externalQueryParamKeys = externalQueryParamKeys;
            paginationData.browserSessionDataPath = sessionDataPath;

            if (selectedCollectionData && selectedCollectionData !== 'undefined') {
              paginationData.externalApiId = selectedCollectionData.externalApiId;
              paginationData.responseDataMapping = selectedCollectionData.responseDataMapping;
              paginationData.bodyDataFrom = selectedCollectionData.bodyDataFrom;
              paginationData.sendFormData = !!selectedCollectionData.sendFormData;
            }
            if (
              !['externalAPIResponse', 'browserSession'].includes(collectionFrom.trim()) &&
              typeof loadBrowserStorageSetterItems !== 'undefined'
            ) {
              console.log('this is this ', this);
              loadBrowserStorageSetterItems(paginationData, this);
            }

            if (
              collectionFrom.trim() === 'externalAPIResponse' &&
              typeof loadBrowserStorageSetterFromExternalAPI !== 'undefined'
            ) {
              console.log('*** Loading Browser-Storage-setter from External API...***');
              loadBrowserStorageSetterFromExternalAPI(paginationData, this);
            }
          },
        },
        init() {
          //Populate Previous External Query from Collection Finder
          const collection = this.get('selectedCollectionData');
          const finder = this.get('finderUuid');
          const finders = collection ? collection.finders : [];
          const selectedFinder = finders.find((currentFinder) => currentFinder.uuid === finder);
          if (selectedFinder && selectedFinder.noOfExternalParams > 0) {
            let pageCollectionOptions = pageCollection ? pageCollection.options : [];
            pageCollectionOptions = pageCollectionOptions.filter((opt) =>
              pageCollectionFields.includes(opt.type),
            );
            const externalQueryParamKeys = [];
            if (selectedFinder.conditions) {
              selectedFinder.conditions.forEach((condition) => {
                if (condition.requiredExternal) {
                  const {
                    query: { value },
                  } = condition;
                  if (value.includes('---')) {
                    const values = value.split('---');
                    externalQueryParamKeys.push(values[0]);
                    externalQueryParamKeys.push(values[1]);
                  } else {
                    externalQueryParamKeys.push(value);
                  }
                }
              });
            }

            if (externalQueryParamKeys.length > 0) {
              externalQueryParamKeys.forEach((extParam) => {
                this.addTrait({
                  name: extParam,
                  label: extParam,
                  options: pageCollectionOptions,
                  title: extParam,
                  type: 'finder-query-param-trait',
                });
              });
            }
          }
          this.on('change:collectionName', this.handleCollectionChange);
          this.on('change:finderUuid', this.handleFinderChange);
        },
        findCustomType(type) {
          const result = [];
          const find = (components) =>
            components.forEach((item) => {
              //Changed to find type
              item.get('custom-type') === type && result.push(item);
              find(item.components());
            });
          find(this.components());
          return result;
        },
        handleCollectionChange() {
          const allTraits = this.get('traits');
          console.log('allTraits :>> ', allTraits);
          const removeTraits = [];
          allTraits.map((trait) => {
            if (trait.props().type === 'finder-query-param-trait') {
              removeTraits.push(trait.props().name);
            }
          });
          removeTraits.map((trait) => this.removeTrait(trait));
        },
        handleFinderChange() {
          const collectionName = this.get('collectionName');
          const collection = this.get('selectedCollectionData');
          const finder = this.get('finderUuid');
          const finders = collection ? collection.finders : [];
          const selectedFinder = finders.find((currentFinder) => currentFinder.uuid === finder);
          const allTraits = this.get('traits');
          const removeTraits = [];
          allTraits.map((trait) => {
            if (trait.props().type === 'finder-query-param-trait') {
              removeTraits.push(trait.props().name);
            }
          });
          removeTraits.map((trait) => this.removeTrait(trait));
          if (selectedFinder && selectedFinder.noOfExternalParams > 0) {
            let pageCollectionOptions = pageCollection ? pageCollection.options : [];
            pageCollectionOptions = pageCollectionOptions.filter((opt) =>
              pageCollectionFields.includes(opt.type),
            );
            const externalQueryParamKeys = [];
            if (selectedFinder.conditions) {
              selectedFinder.conditions.forEach((condition) => {
                if (condition.requiredExternal) {
                  const {
                    query: { value },
                  } = condition;
                  if (value.includes('---')) {
                    const values = value.split('---');
                    externalQueryParamKeys.push(values[0]);
                    externalQueryParamKeys.push(values[1]);
                  } else {
                    externalQueryParamKeys.push(value);
                  }
                }
              });
            }

            if (externalQueryParamKeys.length > 0) {
              externalQueryParamKeys.forEach((extParam) => {
                this.addTrait({
                  name: extParam,
                  label: extParam,
                  options: pageCollectionOptions,
                  title: extParam,
                  type: 'finder-query-param-trait',
                });
              });
            }
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'browser-storage-setter') {
            return {
              type: 'browser-storage-setter',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {
        this.listenTo(model, 'change:collectionName', this.updateScript);
        this.listenTo(model, 'change:finderUuid', this.updateScript);
        this.listenTo(model, 'change:collectionFrom', this.updateScript);
        this.listenTo(model, 'change:sessionDataPath', this.updateScript);
      },
    }),
  });
}
